export default __webpack_public_path__ + "static/media/hackathon-level-2.e4856a61.svg";